// extracted by mini-css-extract-plugin
export var button = "header-module--button--04c6e";
export var buttonWrapper = "header-module--buttonWrapper--2d4f5";
export var highlightCircle = "header-module--highlightCircle--d035d";
export var logo = "header-module--logo--6cb3b";
export var siteTitleText = "header-module--siteTitleText--69539";
export var title = "header-module--title--65f8e";
export var wrapper = "header-module--wrapper--72e96";